import React from 'react';
import PropTypes from 'prop-types';
import screenSizes from 'common-ui-components/lib/core/utils/screenSizes';
import Heading from 'common-ui-components/dist/components/Atoms/Heading';
import ProductRecommendationsSkeleton from '../skeletonEffect/ProductRecommendationsSkeletonEffect';
import ProductRecommendationsTableItem from './ProductRecommendationsTableItem';

class ProductRecommendationsTable extends React.PureComponent {
  constructor(props) {
    super(props);

    const { productRecommendationData } = this.props;

    this.refSlider = React.createRef();
    this.state = {
      isLoad: true,
      isLBSEnabled: false,
      skuListSpecsTable: [...productRecommendationData],
      isMobile: screenSizes.isMobile(),
      activeThumbIndex: 0,
      touchStart: 0,
      touchEnd: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateViewport, true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateViewport, true);
  }

  handleTouchCancel = () => {
    this.setState({ activeThumbIndex: 0 });
  };

  handleTouchMove = e => {
    if (e.cancelable) {
      e.preventDefault();
    }
    this.setState({ touchEnd: e.targetTouches[0].clientX });
  };

  handleTouchStart = e => {
    this.setState({ touchStart: e.targetTouches[0].clientX, touchEnd: 0 });
  };

  updateViewport = () => {
    this.setState({
      isMobile: screenSizes.isMobile(),
    });
  };

  handleTouchEndRC = () => {
    const sliderWidthMobile = this.refSlider?.current?.offsetWidth;
    const { skuListSpecsTable, touchStart, touchEnd, activeThumbIndex } = this.state;

    const difference = touchStart - touchEnd;

    let index = activeThumbIndex;
    if (touchEnd !== 0) {
      if (difference > 0) {
        index += 1;
        if (index > skuListSpecsTable.length - 1) {
          index = skuListSpecsTable.length - 1;
        }
      } else if (difference < 0) {
        index -= 1;
        if (index < 0) index = 0;
      }
    }

    const translate = (sliderWidthMobile + 24) * (index * -1);
    if (this.refSlider?.current) {
      this.refSlider.current.style.transform = `translateX(${translate}px)`;
    }
    this.setState({ activeThumbIndex: index });
  };

  getSkuListItemsPR = skuList => {
    const { isLBSEnabled } = this.state;
    const {
      productRecommendationAddToCart,
      shoppingCartError,
      labels,
      config,
      productRecommendationTitleClick,
    } = this.props;
    return skuList.map((item, index) => (
      <ProductRecommendationsTableItem
        key={item?.skucode}
        rowKey={item?.skucode}
        rowIndex={index}
        skuData={{
          skuNumber: item?.id,
          name: item?.name,
          thumbnailUrl: item?.thumbnailUrl,
          pageUrl: item?.pageUrl,
          purchasable: item?.purchasable,
          isLoading: item?.isLoading,
          activityDetails1: item?.activityDetails1,
        }}
        productRecommendationData={item}
        labels={labels}
        config={config}
        isLBSEnabled={isLBSEnabled}
        productRecommendationAddToCart={productRecommendationAddToCart}
        shoppingCartError={shoppingCartError}
        productRecommendationTitleClick={productRecommendationTitleClick}
      />
    ));
  };

  getThumbnails = skuList => {
    const { activeThumbIndex } = this.state;
    return skuList.map((item, index) => (
      <span
        className={`thumbnail-container ${activeThumbIndex === index && 'thumbnail-active'}`}
        aria-label={`threed-thumbnail-${index}`}
        data-locator="visual-gallery-thumbnail-compare-thumbnail"
        key={`thumbnail-${item?.id}`}
      >
        <div className={`square-img ${activeThumbIndex === index && 'thumbnail-active'}`} />
      </span>
    ));
  };

  render() {
    const {
      productRecommendationData,
      customClassName,
      labels: { productRecommendationTitle },
    } = this.props;
    const { isLoad, skuListSpecsTable, isMobile } = this.state;
    return isLoad && productRecommendationTitle ? (
      <section className={`product-recommendations visualgallery-wrapper ${customClassName}`}>
        <Heading
          HeadingType="h3"
          className="product-recommendations-heading"
          elementLocator="product-recommendations-heading"
        >
          {productRecommendationTitle}
        </Heading>
        <ul
          className="cmp-product-compare-results preview-player-with-nav"
          data-locator="product-compare-results"
        >
          {isMobile ? (
            <div className="slider-wrapper">
              <div
                className="slider"
                id="slider"
                ref={this.refSlider}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={e => this.handleTouchEndRC(e)}
                onTouchCancel={this.handleTouchCancel}
              >
                {this.getSkuListItemsPR(productRecommendationData)}
                {isMobile && <div className="last-preview" />}
              </div>
            </div>
          ) : (
            this.getSkuListItemsPR(productRecommendationData)
          )}
        </ul>
        {isMobile && skuListSpecsTable && (
          <div className="visual-gallery-thumbnail-mobile">
            {this.getThumbnails(skuListSpecsTable)}
          </div>
        )}
      </section>
    ) : (
      <ProductRecommendationsSkeleton />
    );
  }
}

ProductRecommendationsTable.propTypes = {
  labels: PropTypes.objectOf([PropTypes.string]),
  config: PropTypes.objectOf([PropTypes.string]),
  customClassName: PropTypes.string,
  productRecommendationData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      thumbnailUrl: PropTypes.string,
      value: PropTypes.string,
      pageUrl: PropTypes.string,
      likedBy: PropTypes.string,
      inventory: PropTypes.string,
      image: PropTypes.string,
    })
  ),
  productRecommendationAddToCart: PropTypes.func,
  shoppingCartError: PropTypes.objectOf([PropTypes.string]),
  productRecommendationTitleClick: PropTypes.func,
};

ProductRecommendationsTable.defaultProps = {
  labels: {},
  config: {},
  customClassName: '',
  shoppingCartError: {},
  productRecommendationData: [],
  productRecommendationAddToCart: () => {
    /* default productRecommendationAddToCart handler */
  },
  productRecommendationTitleClick: () => {
    /* default productRecommendationTitleClick handler */
  },
};

export default ProductRecommendationsTable;
